import { createReducer } from "@reduxjs/toolkit";
import { TYPES } from "../../../common/constants";

const initialState = {
  Statuses: [],
  selectedDate: null,
  UnitId: [],
  TagIds: [],
  booleanFilters: [],
  SubmittedFrom: null,
  SubmittedTo: null,
  PropertyId: null,
  BuildingId: null,
  LevelId: null,
  ItemTypeId: null,
};

const removeFilter = (state, { payload }) => {
  const { key } = payload;
  return { ...state, [key]: initialState[key] };
};

const applyFilter = (state, { payload }) => {
  const { key, data } = payload;
  return { ...state, [key]: data };
};

const applyFilters = (state, { payload }) => {
  return { ...state, ...payload };
};

export default createReducer(initialState, {
  [TYPES.SERVICE_REQUEST_FILTERS_ADD]: applyFilter,
  [TYPES.SERVICE_REQUEST_FILTERS_BULK_ADD]: applyFilters,
  [TYPES.SERVICE_REQUEST_FILTERS_REMOVE]: removeFilter,
  [TYPES.SERVICE_REQUEST_FILTERS_CLEAR]: () => initialState,
});

